export const isStringNullOrEmpty = (str: string): boolean => {
  return str === undefined || str === null || str === '';
};

export const isStringNullOrWhiteSpace = (str: string): boolean => {
  return str === undefined || str === null || str.trim() === '';
};

export const isStringTrimmed = (str: string): boolean => {
  return str === str.trim();
};

export const isStringNotEmptyAndTrimmed = (str: string): boolean => {
  return !isStringNullOrWhiteSpace(str) && isStringTrimmed(str);
};

export const hasAtLeastLetterOrNumber = (str: string): boolean => {
  const regexp = new RegExp('[a-zA-Z0-9]');
  return regexp.test(str);
};

export const indexOfInsensitive = (str1: string, str2: string) => {
  let isStr1Null = isStringNullOrEmpty(str1);
  let isStr2Null = isStringNullOrEmpty(str2);
  if (!isStr1Null && !isStr2Null) {
    return str1.toLocaleLowerCase().indexOf(str2.toLocaleLowerCase());
  }

  return isStr1Null === isStr2Null ? 0 : -1;
};

export const equalsInsensitive = (str1: string, str2: string): boolean => {
  return str1.toLocaleLowerCase() === str2.toLocaleLowerCase();
};

export const getStringOrEmpty = (str1: string): string => {
  if (isStringNullOrWhiteSpace(str1)) {
    return '';
  } else {
    return str1;
  }
};
